import { useContext, useState } from "react";
import { SubscriptionsContext } from "../../../store/SubscriptionsContext";
import type { ModalConfig } from "../../../utils/types";
import { Subscription } from "../../../../../api/subscriptions";
import "../../../modals/Modal.css";

export type CreateSubscriptionModalBodyProps = {
  openMessage: (message: ModalConfig) => void;
  onClose: () => void;
};

export function CreateSubscriptionModalBody({
  openMessage,
  onClose,
}: CreateSubscriptionModalBodyProps) {
  const { createSubscription } = useContext(SubscriptionsContext);

  const [isCombo, setIsCombo] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event?.preventDefault();

    if (isSubmitting) return;
    setIsSubmitting(true);

    const fd = new FormData(event.currentTarget);
    const data = Object.fromEntries(fd.entries());

    try {
      await createSubscription({
        name: data.subscriptionType as string,
        spots: isCombo ? undefined : Number(data.availableSpots),
        isCombo: isCombo,
      } as Subscription);

      onClose();
      openMessage({
        title: "Success!",
        body: `New Subscription Type has been created successfully!`,
        showCloseButton: true,
      });
    } catch (err: unknown) {
      const msg =
        (err as { response?: { data?: { message?: string } } })?.response?.data
          ?.message ?? "Failed to create subscription type";
      onClose();
      openMessage({ body: msg });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="new-harvest-log-wrapper">
      <form onSubmit={handleSubmit}>
        <div className="modal-form-input-pair">
          <label htmlFor="subscription-type" className="sr-only">
            Subscription Type
          </label>
          <input
            type="text"
            name="subscriptionType"
            id="subscription-type"
            placeholder="Subscription Type"
            required
          />
          {!isCombo && (
            <>
              <label htmlFor="available-spots" className="sr-only">
                Available Spots
              </label>
              <input
                type="number"
                name="availableSpots"
                id="available-spots"
                placeholder="Available Spots"
                required={!isCombo}
              />
            </>
          )}
        </div>
        <div className="modal-form-input-pair-checkbox">
          <label>
            <input
              type="checkbox"
              name="comboCheckbox"
              checked={isCombo}
              onChange={(e) => setIsCombo(e.target.checked)}
            />
            This is a compo subscription.
          </label>
        </div>
        <div className="buttons-footer">
          <button type="button" className="btn equal-btns" onClick={onClose}>
            Cancel
          </button>
          <button
            type="submit"
            className="btn equal-btns"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Creating..." : "Create"}
          </button>
        </div>
        <p>
          <span className="gray-text">* Tiers can be created after.</span>
        </p>{" "}
        <p>
          <span className="gray-text">
            * Combo subscriptions have no available spots themselves. They fetch
            availability from multipal other subscriptions. Ex: Flowers &
            Veggies take 1 spot from Veggies and 1 spot form Flowers
          </span>
        </p>
      </form>
    </div>
  );
}
